define([
  'underscore',
], (_) => {
  // WARNING! We aren't using the weights anymore and instead loading all of them
  // with italics as well.  There is no guarantee the weights are correct.
  const GOOGLE_FONT_OPTIONS = [
    { face: 'Abril Fatface', generic: 'cursive', weights: ['400'] },
    { face: 'Alice', generic: 'serif', weights: ['400'] },
    { face: 'Amaranth', generic: 'sans-serif', weights: ['700', '400'] },
    { face: 'Antic Slab', generic: 'serif', weights: ['400'] },
    { face: 'Archivo Black', generic: 'sans-serif', weights: ['400'] },
    { face: 'Arimo', generic: 'sans-serif', weights: ['700', '400'] },
    { face: 'Asul', generic: 'sans-serif', weights: ['400'] },
    { face: 'Bad Script', generic: 'cursive', weights: ['400'] },
    { face: 'Baumans', generic: 'cursive', weights: ['400'] },
    { face: 'Bevan', generic: 'cursive', weights: ['400'] },
    { face: 'Bitter', generic: 'serif', weights: ['700', '400'] },
    { face: 'Black Ops One', generic: 'cursive', weights: ['400'] },
    { face: 'Bowlby One SC', generic: 'cursive', weights: ['400'] },
    { face: 'Bree Serif', generic: 'serif', weights: ['400'] },
    { face: 'Buenard', generic: 'serif', weights: ['700', '400'] },
    { face: 'Bungee', generic: 'cursive', weights: ['400'] },
    { face: 'Butterfly Kids', generic: 'cursive', weights: ['400'] },
    { face: 'Cabin Sketch', generic: 'cursive', weights: ['700', '400'] },
    { face: 'Cantarell', generic: 'sans-serif', weights: ['400'] },
    { face: 'Cardo', generic: 'serif', weights: ['400'] },
    { face: 'Changa One', generic: 'cursive', weights: ['400'] },
    { face: 'Chewy', generic: 'cursive', weights: ['400'] },
    { face: 'Chivo', generic: 'sans-serif', weights: ['400'] },
    { face: 'Codystar', generic: 'cursive', weights: ['400', '300'] },
    { face: 'Comfortaa', generic: 'cursive', weights: ['700', '400', '300'] },
    { face: 'Concert One', generic: 'cursive', weights: ['400'] },
    { face: 'Courgette', generic: 'cursive', weights: ['400'] },
    { face: 'Crete Round', generic: 'serif', weights: ['400'] },
    { face: 'Damion', generic: 'cursive', weights: ['400'] },
    { face: 'Dancing Script', generic: 'cursive', weights: ['700', '400'] },
    { face: 'Dosis', generic: 'sans-serif', weights: ['800', '700', '600', '500', '400', '300', '200'] },
    { face: 'Droid Sans', generic: 'sans-serif', weights: ['700', '400'] },
    { face: 'Eczar', generic: 'serif', weights: ['400'] },
    { face: 'Emilys Candy', generic: 'cursive', weights: ['400'] },
    { face: 'Fira Mono', generic: 'monospace', weights: ['400'] },
    { face: 'Fira Sans', generic: 'sans-serif', weights: ['400'] },
    { face: 'Fjalla One', generic: 'sans-serif', weights: ['400'] },
    { face: 'Fredericka the Great', generic: 'cursive', weights: ['400'] },
    { face: 'Fredoka One', generic: 'cursive', weights: ['400'] },
    { face: 'Graduate', generic: 'cursive', weights: ['400'] },
    { face: 'Gravitas One', generic: 'cursive', weights: ['400'] },
    { face: 'Josefin Sans', generic: 'sans-serif', weights: ['700', '600', '400', '300', '100'] },
    { face: 'Josefin Slab', generic: 'serif', weights: ['700', '600', '400', '300', '100'] },
    { face: 'Indie Flower', generic: 'cursive', weights: ['400'] },
    { face: 'Lato', generic: 'sans-serif', weights: ['900', '700', '400', '300', '100'] },
    { face: 'Libre Baskerville', generic: 'serif', weights: ['400'] },
    { face: 'Lilita One', generic: 'cursive', weights: ['400'] },
    { face: 'Lily Script One', generic: 'cursive', weights: ['400'] },
    { face: 'Lobster Two', generic: 'cursive', weights: ['700', '400'] },
    { face: 'Lora', generic: 'serif', weights: ['900', '700', '500', '400'] },
    { face: 'Lusitana', generic: 'serif', weights: ['700', '400'] },
    { face: 'Maven Pro', generic: 'sans-serif', weights: ['700', '400'] },
    { face: 'Merriweather', generic: 'serif', weights: ['900', '700', '400', '300'] },
    { face: 'Monoton', generic: 'cursive', weights: ['400'] },
    { face: 'Montserrat', generic: 'sans-serif', weights: ['900', '800', '700', '600', '500', '400', '300', '200', '100'] },
    { face: 'Muli', generic: 'sans-serif', weights: ['400'] },
    { face: 'Nixie One', generic: 'cursive', weights: ['400'] },
    { face: 'Noticia Text', generic: 'serif', weights: ['700', '400'] },
    { face: 'Nunito', generic: 'sans-serif', weights: ['900', '800', '700', '600', '400', '300', '200'] },
    { face: 'Open Sans', generic: 'sans-serif', weights: ['800', '700', '600', '400', '300'] },
    { face: 'Open Sans Condensed', generic: 'sans-serif', weights: ['300'] },
    { face: 'Oswald', generic: 'sans-serif', weights: ['700', '600', '500', '400', '300', '200'] },
    { face: 'Parisienne', generic: 'cursive', weights: ['400'] },
    { face: 'Pathway Gothic One', generic: 'sans-serif', weights: ['400'] },
    { face: 'Permanent Marker', generic: 'cursive', weights: ['400'] },
    { face: 'Playfair Display', generic: 'serif', weights: ['900', '700', '400'] },
    { face: 'PT Mono', generic: 'monospace', weights: ['400'] },
    { face: 'PT Serif', generic: 'serif', weights: ['400', '700'] },
    { face: 'Quando', generic: 'serif', weights: ['400'] },
    { face: 'Quattrocento Sans', generic: 'sans-serif', weights: ['700', '400'] },
    { face: 'Quicksand', generic: 'sans-serif', weights: ['700', '500', '400', '300'] },
    { face: 'Qwigley', generic: 'cursive', weights: ['400'] },
    { face: 'Raleway', generic: 'sans-serif', weights: ['900', '800', '700', '600', '500', '400', '300', '200', '100'] },
    { face: 'Reenie Beanie', generic: 'cursive', weights: ['400'] },
    { face: 'Roboto', generic: 'sans-serif', weights: ['900', '700', '500', '400', '300', '100'] },
    { face: 'Roboto Mono', generic: 'monospace', weights: ['400'] },
    { face: 'Roboto Slab', generic: 'serif', weights: ['900', '700', '500', '400', '300', '100'] },
    { face: 'Rock Salt', generic: 'cursive', weights: ['400'] },
    { face: 'Rokkitt', generic: 'serif', weights: ['900', '800', '700', '600', '500', '400', '300', '200', '100'] },
    { face: 'Rubik', generic: 'sans-serif', weights: ['400'] },
    { face: 'Russo One', generic: 'sans-serif', weights: ['400'] },
    { face: 'Rye', generic: 'cursive', weights: ['400'] },
    { face: 'Sacramento', generic: 'cursive', weights: ['400'] },
    { face: 'Sansita One', generic: 'cursive', weights: ['400', '700', '800', '900'] },
    { face: 'Satisfy', generic: 'cursive', weights: ['400'] },
    { face: 'Shadows Into Light Two', generic: 'cursive', weights: ['400'] },
    { face: 'Share Tech Mono', generic: 'monospace', weights: ['400'] },
    { face: 'Slabo 27px', generic: 'serif', weights: ['400'] },
    { face: 'Source Sans Pro', generic: 'sans-serif', weights: ['900', '700', '600', '400', '300', '200'] },
    { face: 'Special Elite', generic: 'cursive', weights: ['400'] },
    { face: 'Syncopate', generic: 'sans-serif', weights: ['400'] },
    { face: 'Taviraj', generic: 'serif', weights: ['400'] },
    { face: 'Tenor Sans', generic: 'sans-serif', weights: ['400'] },
    { face: 'The Girl Next Door', generic: 'cursive', weights: ['400'] },
    { face: 'Ubuntu', generic: 'sans-serif', weights: ['700', '500', '400', '300'] },
    { face: 'Unica One', generic: 'cursive', weights: ['400'] },
    { face: 'VT323', generic: 'monospace', weights: ['400'] },
    { face: 'Yanone Kaffeesatz', generic: 'sans-serif', weights: ['700', '400', '300', '200'] },
    { face: 'Vesper Libre', generic: 'serif', weights: ['400'] },
    { face: 'Vollkorn', generic: 'serif', weights: ['400'] },
    { face: 'Work Sans', generic: 'sans-serif', weights: ['400'] },
    { face: 'Yellowtail', generic: 'cursive', weights: ['400'] },
  ];

  const GOOGLE_FONT_OPTIONS2 = [
    { face: 'Albert Sans', generic: 'sans-serif', weights: ['900', '800', '700', '600', '500', '400', '300', '200', '100'] },
    { face: 'Antic Didone', generic: 'serif', weights: ['400'] },
    { face: 'Arapey', generic: 'serif', weights: ['400'] },
    { face: 'Cormorant Garamond', generic: 'serif', weights: ['700', '600', '500', '400', '300'], isStatic: true },
    { face: 'DM Serif Text', generic: 'serif', weights: ['400'] },
    { face: 'Inter', generic: 'sans-serif', weights: ['900', '800', '700', '600', '500', '400', '300', '200', '100'] },
    { face: 'Libre Bodoni', generic: 'serif', weights: ['700', '600', '500', '400'] },
    { face: 'Nanum Myeongjo', generic: 'serif', weights: ['700', '400'] },
    { face: 'Noto Serif Display', generic: 'serif', weights: ['900', '800', '700', '600', '500', '400', '300', '200', '100'] },
    { face: 'Petit Formal Script', generic: 'cursive', weights: ['400'] },
    { face: 'Poppins', generic: 'sans-serif', weights: ['900', '800', '700', '600', '500', '400', '300', '200', '100'], isStatic: true, },
    { face: 'Prata', generic: 'serif', weights: ['400'] },
    { face: 'Questrial', generic: 'sans-serif', weights: ['400'] },
    { face: 'Source Code Pro', generic: 'monospace', weights: ['900', '800', '700', '600', '500', '400', '300', '200'] },
  ];

  const BROWSER_DEFAULT_FONT_OPTIONS = [
    { face: 'Arial', family: 'Arial,Helvetica Neue,Helvetica,sans-serif', weights: ['300', '400', '500', '700'] },
    { face: 'Arial Black', family: 'Arial Black,Arial Bold,Gadget,sans-serif', weights: ['300', '400', '500', '700'] },
    { face: 'Arial Narrow', family: 'Arial Narrow,Arial,sans-serif', weights: ['300', '400', '500', '700'] },
    { face: 'Verdana', family: 'Verdana,Geneva,sans-serif', weights: ['300', '400', '500', '700'] },
    { face: 'Trebuchet MS', family: 'Trebuchet MS,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Tahoma,sans-serif', weights: ['300', '400', '500', '700'] },
    { face: 'Tahoma', family: 'Tahoma,Verdana,Segoe,sans-serif', weights: ['300', '400', '500', '700'] },
    { face: 'Georgia', family: 'Georgia,Times,Times New Roman,serif', weights: ['300', '400', '500', '700'] },
    { face: 'Palatino', family: 'Palatino,Palatino Linotype,Palatino LT STD,Book Antiqua,Georgia,serif', weights: ['300', '400', '500', '700'] },
    { face: 'Times New Roman', family: 'TimesNewRoman,Times New Roman,Times,Baskerville,Georgia,serif', weights: ['300', '400', '500', '700'] },
    { face: 'Courier New', family: 'Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace', weights: ['300', '400', '500', '700'] },
  ];

  // Concat browser defaults and google fonts and then sort them by face.
  const FONT_OPTIONS = _.sortBy([].concat(
    GOOGLE_FONT_OPTIONS,
    GOOGLE_FONT_OPTIONS2,
    BROWSER_DEFAULT_FONT_OPTIONS,
  ), 'face');

  const STYLE_OPTIONS = [
    { label: 'Super-Bold', value: '900' },
    { label: 'Super-Bold Italic', value: '900italic' },
    { label: 'Extra-Bold', value: '800' },
    { label: 'Extra-Bold Italic', value: '800italic' },
    { label: 'Bold', value: '700' },
    { label: 'Bold Italic', value: '700italic' },
    { label: 'Semi-Bold', value: '600' },
    { label: 'Semi-Bold Italic', value: '600italic' },
    { label: 'Medium', value: '500' },
    { label: 'Medium Italic', value: '500italic' },
    { label: 'Normal', value: '400' },
    { label: 'Italic', value: '400italic' },
    { label: 'Light', value: '300' },
    { label: 'Light Italic', value: '300italic' },
    { label: 'Extra-Light', value: '200' },
    { label: 'Extra-Light Italic', value: '200italic' },
    { label: 'Thin', value: '100' },
    { label: 'Thin Italic', value: '100italic' },
  ];

  const fontSizeOptions = [
    { label: '8px', value: '8px' },
    { label: '9px', value: '9px' },
    { label: '10px', value: '10px' },
    { label: '11px', value: '11px' },
    { label: '12px', value: '12px' },
    { label: '13px', value: '13px' },
    { label: '14px', value: '14px' },
    { label: '16px', value: '16px' },
    { label: '18px', value: '18px' },
    { label: '20px', value: '20px' },
    { label: '23px', value: '23px' },
    { label: '26px', value: '26px' },
    { label: '29px', value: '29px' },
    { label: '30px', value: '30px' },
    { label: '32px', value: '32px' },
    { label: '36px', value: '36px' },
    { label: '48px', value: '48px' },
    { label: '60px', value: '60px' },
    { label: '72px', value: '72px' },
    { label: '96px', value: '96px' },
  ];

  function isBrowserFont(fontFace) {
    return !!_.findWhere(BROWSER_DEFAULT_FONT_OPTIONS, { face: fontFace });
  }

  function isGoogleFont(fontFace) {
    return !!_.findWhere(GOOGLE_FONT_OPTIONS, { face: fontFace });
  }

  function isGoogleFont2(fontFace) {
    return !!_.findWhere(GOOGLE_FONT_OPTIONS2, { face: fontFace });
  }

  function getFontOption(fontFace) {
    // Clone so we don't modify the our font lookup array.
    return _.clone(_.findWhere(FONT_OPTIONS, { face: fontFace }));
  }

  function getFontSizeOption(fontSize) {
    // Clone so we don't modify the our font lookup array.
    return _.clone(_.findWhere(fontSizeOptions, { value: fontSize }));
  }

  function parseFontFamily(fontFamily) {
    if (!fontFamily || !fontFamily.length) return null;
    const fontFamilyParts = fontFamily.replace(/\'/g, '').split(',');

    return {
      face: fontFamilyParts[0],
      generic: fontFamilyParts[1],
    };
  }

  function toRanges(arr) {
    if(!Array.isArray(arr) || arr.length === 0) {
      throw new Error('Input should be a non-empty array.');
    }

    // Sort array in ascending order
    arr.sort((a, b) => a - b);

    let result = '';
    let start = arr[0];
    let end;

    for (let i = 1; i < arr.length; i++) {
      // If the current number isn't contiguous by 100 with the previous
      if (arr[i] - arr[i - 1] !== 100) {
        end = arr[i - 1];
        result += start === end ? `${start};` : `${start}..${end};`;
        start = arr[i];
      }
    }

    // Handle the last contiguous range or remaining number
    end = arr[arr.length - 1];
    result += start === end ? `${start}` : `${start}..${end}`;

    return result;
  }

  function fullGoogleFontUrl(font) {
    if (isGoogleFont(font.face)) {
      const url = `https://fonts.googleapis.com/css?family=${font.face.replace(/ /g, '+')}`;
      const fontWeights = _.pluck(STYLE_OPTIONS, 'value').join(',');

      return `${url}:${fontWeights}`;
    }

    if (isGoogleFont2(font.face)) {
      const url = `https://fonts.googleapis.com/css2?family=${font.face.replace(/ /g, '+')}`;
      const fontOption = _.findWhere(GOOGLE_FONT_OPTIONS2, { face: font.face });

      if (fontOption) {
        return url;
      }

      if (fontOption.isStatic) {
        return `${url}:wght@${fontOption.weights.join(';')}&display=swap`
      }

      return `${url}:wght@${toRanges(fontOption.weights)}&display=swap`
    }

    return false;
  }

  function googleFontUrl(font) {
    let url = `//fonts.googleapis.com/css?family=${font.face.replace(' ', '+')}`;
    let fontWeight = font.weight || '400';

    // We want to load Open Sans weights for the site style as well as the selected
    // font style since the browser can have only one font file at a time.
    if (font.face === 'Open Sans') fontWeight = `${fontWeight},600`;
    if (fontWeight) url = `${url}:${fontWeight}`;

    return url;
  }

  function fullGoogleFontUrlFromFontFamily(fontFamily) {
    return fullGoogleFontUrl(parseFontFamily(fontFamily));
  }

  return {
    STYLE_OPTIONS,
    FONT_OPTIONS,
    GOOGLE_FONT_OPTIONS,
    BROWSER_DEFAULT_FONT_OPTIONS,
    fontSizeOptions,

    isBrowserFont,

    getFontOption,
    getFontSizeOption,

    parseFontFamily,

    googleFontUrl,
    fullGoogleFontUrl,
    fullGoogleFontUrlFromFontFamily,
  };
});
